import { gql } from '@apollo/client';
import { verificationTypeItem, verificationFormula } from './fragments';

export const VERIFICATION_TYPE_UPDATED = gql`
  subscription verificationTypeUpdated {
    verificationTypeUpdated {
      verificationType {
        ...verificationTypeItem
      }
    }
  }
  ${verificationTypeItem}
`;

export const VERIFICATION_FORMULA_GENERATED = gql`
  subscription verificationFormulaGenerated {
    verificationFormulaGenerated {
      verificationFormulas {
        ...verificationFormula
      }
    }
  }
  ${verificationFormula}
`;

export const TEST_FORMULA_VERIFICATION_FAILED = gql`
  subscription testFormulaVerificationFailed {
    testFormulaVerificationFailed {
      verificationTypeId
      errorMessage
    }
  }
`;
